import { useTheme } from "@mui/material";

function Education3dpSnailGraphic() {
  const { palette } = useTheme();

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 441 118"
      fill="none"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4179_67362)">
        <rect width="441" height="118" fill="url(#paint0_linear_4179_67362)" />
        <path
          d="M0 1C0 0.447718 0.447715 0 1 0H440C440.552 0 441 0.447715 441 1V111C441 111.552 440.552 118 440 118H1.00001C0.447726 118 0 111.552 0 111V1Z"
          fill="url(#paint1_linear_4179_67362)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M221.016 34.748C224.732 34.7481 228.38 35.7439 231.581 37.6309C234.782 39.518 237.42 42.2277 239.218 45.4785C241.016 48.7294 241.909 52.4031 241.806 56.1162C241.702 59.8293 240.605 63.4472 238.628 66.5928L238.625 66.5898C237.814 68.3079 236.065 69.497 234.038 69.4971C231.238 69.4971 228.968 67.2283 228.968 64.4297C228.968 63.22 229.393 62.1096 230.101 61.2383L230.041 61.2021C231.054 59.5901 231.617 57.7359 231.67 55.833C231.723 53.9303 231.265 52.0477 230.344 50.3818C229.422 48.716 228.071 47.3274 226.431 46.3604C224.79 45.3933 222.92 44.8828 221.016 44.8828V34.748Z"
          fill="url(#paint2_linear_4179_67362)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M220.684 21.8115C225.667 21.8115 230.591 22.8929 235.115 24.9805C239.639 27.0679 243.656 30.1119 246.889 33.9023C250.121 37.6929 252.493 42.1399 253.838 46.9355C255.183 51.7312 255.471 56.762 254.682 61.6797C253.892 66.5975 252.044 71.2857 249.265 75.4199C246.486 79.5542 242.842 83.0365 238.585 85.626C234.328 88.2154 229.56 89.8501 224.609 90.418C220.099 90.9353 215.535 90.5521 211.18 89.3018C208.563 89.0595 206.514 86.8597 206.514 84.1807C206.514 81.3398 208.818 79.0371 211.66 79.0371C212.365 79.0371 213.037 79.1792 213.648 79.4355C216.819 80.3957 220.155 80.6983 223.45 80.3203C226.939 79.9202 230.298 78.7679 233.298 76.9434C236.297 75.1188 238.865 72.665 240.823 69.752C242.781 66.8387 244.084 63.5347 244.641 60.0693C245.197 56.6041 244.994 53.059 244.046 49.6797C243.098 46.3004 241.427 43.1671 239.149 40.4961C236.872 37.825 234.041 35.68 230.853 34.209C227.665 32.7381 224.195 31.9766 220.684 31.9766V21.8115Z"
          fill="url(#paint3_linear_4179_67362)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M220.275 8.6875C230.659 8.6875 240.761 12.0664 249.053 18.3145C257.344 24.5626 263.375 33.3401 266.232 43.3184C269.09 53.2965 268.619 63.9333 264.891 73.6201C261.259 83.0562 254.728 91.0894 246.248 96.5752C245.371 97.2681 244.264 97.6836 243.059 97.6836C240.214 97.6836 237.907 95.3784 237.907 92.5352C237.907 90.4754 239.118 88.6982 240.866 87.875C247.445 83.5665 252.512 77.2986 255.341 69.9482C258.271 62.3349 258.64 53.9751 256.395 46.1328C254.149 38.2905 249.409 31.3921 242.893 26.4814C236.376 21.5708 228.437 18.9141 220.275 18.9141V8.6875Z"
          fill="url(#paint4_linear_4179_67362)"
        />
        <rect y="8.68701" width="221.608" height="10.135" fill="#A7EDFF" />
        <rect y="21.7178" width="221.608" height="10.135" fill="#FEF39B" />
        <rect y="34.7485" width="221.608" height="10.135" fill="#FFCEA1" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4179_67362"
          x1="220.5"
          y1="0"
          x2="220.5"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette.background.level1} />
          <stop offset="1" stopColor={palette.background.level2} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4179_67362"
          x1="220.5"
          y1="0"
          x2="220.5"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette.background.level1} />
          <stop offset="1" stopColor={palette.background.level2} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4179_67362"
          x1="221.59"
          y1="40.8057"
          x2="221.016"
          y2="74.3535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCEA1" />
          <stop offset="1" stopColor="#FF8400" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4179_67362"
          x1="233.369"
          y1="86.0311"
          x2="225.14"
          y2="29.0556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FECF12" />
          <stop offset="1" stopColor="#FEF39B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4179_67362"
          x1="222.377"
          y1="16.9132"
          x2="199.109"
          y2="96.9012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7EDFF" />
          <stop offset="1" stopColor="#02C4F5" />
        </linearGradient>
        <clipPath id="clip0_4179_67362">
          <rect width="441" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Education3dpSnailGraphic;
